<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#007BFF"
      :is-full-page="true"
    >
    </loading>
    <div class="container-fluid">
      <div class="card  pt-3">
        <div class="row starter-page">
          <div class="container-fluid ">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mb-3"
            >
              <div class="d-flex align-items-center flex-wrap">
                <base-button
                  type="success"
                  @click="downloadExcel"
                  :disabled="isExporting"
                >
                  <i class="fas fa-file-excel mr-1" v-if="!isExporting"></i>
                  <i class="fas fa-spinner fa-spin mr-1" v-else></i>
                  EXCEL
                </base-button>
                <span class="ml-3 font-weight-bold"
                  >Total : {{ filteredFeedbacks.length }}</span
                >
              </div>
              <div class="d-flex align-items-center flex-wrap">
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Buscar...."
                  class="mr-2"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-3 col-12 mb-2">
                <el-select
                  v-model="selectedKitchen"
                  filterable
                  clearable
                  placeholder="Franquicia"
                  style="width: 100%"
                >
                  <el-option
                    v-for="kitchen in dark_kitchens"
                    :key="kitchen.id"
                    :label="kitchen.name"
                    :value="kitchen.id"
                  />
                </el-select>
              </div>
              <div class="col-md-3 col-12 mb-2">
                <flat-picker
                  v-model="dateRange"
                  :config="dateConfig"
                  placeholder="Rango de Fecha"
                  class="form-control"
                  style="width: 100%"
                />
              </div>
              <div class="col-md-3 col-12 mb-2">
                <el-select
                  v-model="selectedRating"
                  clearable
                  placeholder="Calificación"
                  style="width: 100%"
                >
                  <el-option
                    v-for="r in ratings"
                    :key="r.id"
                    :label="r.name"
                    :value="r.id"
                  />
                </el-select>
              </div>
              <div class="col-md-3 col-12 mb-2 d-flex align-items-center">
                <base-button type="primary" class="mr-2" @click="applyFilters">
                  <i class="fas fa-search mr-1"></i> BUSCAR
                </base-button>
                <base-button type="default" @click="clearFilters"
                  >LIMPIAR</base-button
                >
              </div>
            </div>
            <vue-content-loading
              v-if="!loaded"
              :width="300"
              :height="170"
              primary="#bdc3c7"
              secondary="#95a5a6"
            >
              <svg:rect x="20" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="0" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="15" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="30" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="45" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="60" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="75" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="90" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="105" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="120" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="135" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="150" rx="3" ry="3" width="110" height="8" />
              <circle cx="206" cy="155" r="5" />
              <circle cx="219" cy="155" r="5" />
              <circle cx="232" cy="155" r="5" />
              <circle cx="245" cy="155" r="5" />
            </vue-content-loading>

            <el-table
              :data="filteredFeedbacks"
              row-key="id"
              header-row-class-name="thead-light"
              v-loading="isLoading"
              style="width: 100%"
            >
              <el-table-column
                prop="dark_kitchen_name"
                label="Franquicia"
                min-width="180"
              />
              <el-table-column label="Calificación" min-width="120">
                <template slot-scope="scope">
                  <el-tag
                    :type="getRatingTagType(scope.row.rating)"
                    effect="dark"
                  >
                    {{ scope.row.rating_text }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="Categoria" min-width="180">
                <template slot-scope="scope">
                  <el-tag
                    v-for="(category_aspect, idx) in getAspects(scope.row.category_aspects)"
                    :key="idx"
                    type="success"
                    class="mr-1 mb-1"
                  >
                    {{ getAspectText(category_aspect) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="Aspectos" min-width="180">
                <template slot-scope="scope">
                  <el-tag
                    v-for="(aspect, idx) in getAspects(scope.row.aspects)"
                    :key="idx"
                    type="success"
                    class="mr-1 mb-1"
                  >
                    {{ getAspectText(aspect) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="comments"
                label="Comentarios"
                min-width="180"
              />
              <el-table-column label="Fecha" min-width="120">
                <template slot-scope="scope">
                  {{ formatDate(scope.row.created_at) }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <CustomModal
      :is-modal="selectedFeedback != null"
      @closeModal="selectedFeedback = null"
      :closeOuth="true"
      width="xlg"
    >
    </CustomModal>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option, Tag } from "element-ui";
import BackofficeApi from "../../gateways/backoffice-api";
import { VueContentLoading } from "vue-content-loading";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es";
import Loading from "vue-loading-overlay";
import CustomModal from "../../components/CustomModal";

import "vue-loading-overlay/dist/vue-loading.css";
import Fuse from "fuse.js";
import { format, subDays, parse, addDays } from "date-fns";
import moment from "moment";

export default {
  name: "FeedbackFranchise",
  components: {
    // BasePagination,
    VueContentLoading,
    CustomModal,

    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tag.name]: Tag,
    flatPicker,
    Loading
  },
  data() {
    return {
      loaded: false,
      selectedFeedback: null,
      searchQuery: "",
      searchedData: [],
      isLoading: false,
      isExporting: false,
      tableColumns: [
        {
          prop: "at",
          label: "Fecha",
          minWidth: 125,
          sortable: true
        },
        {
          prop: "customer",
          label: "Cliente",
          minWidth: 150,
          sortable: true
        },
        {
          prop: "restaurant_qualification",
          label: "Calificación",
          minWidth: 150,
          sortable: true
        }
      ],
      feedbacks: [],
      dark_kitchens: [],
      selectedKitchen: null,
      selectedRating: null,
      dateRange: null,
      currentFilters: {},
      ratings: [
        { id: null, name: "todos" },
        { id: 5, name: "Muy satisfecho" },
        { id: 4, name: "Satisfecho" },
        { id: 3, name: "Neutral" },
        { id: 2, name: "Insatisfecho" },
        { id: 1, name: "Muy insatisfecho" }
      ],
      dateConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        locale: Spanish
      },
      aspectsMap: {
        tiempo_aceptable: "Tiempo aceptable",
        calidad_buena: "Calidad buena",
        calidad_neutral: "Calidad neutral",
        calidad_negativa: "Calidad negativa",
        trato_negativo: "Trato negativo"
      }
    };
  },
  async mounted() {
    await this.fetchFeedbacks();
  },
  computed: {
    filteredFeedbacks() {
      let data = this.feedbacks;

      // Aplicar filtro de búsqueda local
      if (this.searchQuery) {
        const q = this.searchQuery.toLowerCase();
        data = data.filter(
          f =>
            (f.dark_kitchen_name &&
              f.dark_kitchen_name.toLowerCase().includes(q)) ||
            (f.comments && f.comments.toLowerCase().includes(q)) ||
            (f.other_aspect && f.other_aspect.toLowerCase().includes(q))
        );
      }
      return data;
    },
    excelName() {
      if (!this.dateRange || !this.dateRange.length) {
        return `Opiniones-${moment().format("YYYY-MM-DD")}.xlsx`;
      }

      var frLocale = require("date-fns/locale/es");
      const formatedDates = this.dateRange.map(date => {
        const parsed = parse(date, "YYYY-MM-DD", new Date());
        return format(parsed, "MMM DD", { locale: frLocale });
      });
      return `Opiniones ${formatedDates.join(" - ")}.xlsx`.toUpperCase();
    },
    host() {
      return process.env.VUE_APP_API_BACKOFFICE_URL.replace("/api/v1/", "");
    }
  },
  methods: {
    showDetails(order) {
      this.selectedFeedback = order;
    },
    async fetchFeedbacks(filters = {}) {
      this.isLoading = true;
      try {
        const path =
          process.env.VUE_APP_API_BACKOFFICE_URL + "feedback-franchises";

        // Guardar los filtros actuales para usarlos en la exportación
        this.currentFilters = { ...filters };

        const response = await BackofficeApi.get(path, { params: filters });
        this.feedbacks = response.data.data.feedbacks;
        this.dark_kitchens = response.data.data.dark_kitchens;
      } catch (e) {
        console.error("Error al cargar los datos:", e);
        this.feedbacks = [];
        this.dark_kitchens = [];
      } finally {
        this.isLoading = false;
        this.loaded = true;
      }
    },
    applyFilters() {
      // Solo aplicar filtros al presionar BUSCAR
      const filters = {};
      if (this.selectedKitchen) filters.dark_kitchen_id = this.selectedKitchen;
      if (this.selectedRating) filters.rating = this.selectedRating;
      let range = this.dateRange;
      if (typeof range === "string") {
        range = range.split(" a ").map(s => s.trim());
      }
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        filters.start_date = range[0];
        filters.end_date = range[1];
      }
      this.fetchFeedbacks(filters);
    },
    clearFilters() {
      this.selectedKitchen = null;
      this.selectedRating = null;
      this.dateRange = null;
      this.searchQuery = "";
      this.fetchFeedbacks({});
    },
    getAspects(aspects) {
      try {
        return JSON.parse(aspects).filter(a => a !== "otro");
      } catch {
        return [];
      }
    },
    getAspectText(aspect) {
      return this.aspectsMap[aspect] || aspect;
    },
    getRatingTagType(rating) {
      switch (rating) {
        case 5:
          return "success";
        case 4:
          return "success";
        case 3:
          return "warning";
        case 2:
          return "danger";
        case 1:
          return "danger";
        default:
          return "info";
      }
    },
    formatDate(date) {
      return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm");
    },
    async downloadExcel() {
      this.isExporting = true;
      try {
        const path =
          process.env.VUE_APP_API_BACKOFFICE_URL + "feedback-franchises/export";

        // Usar los mismos filtros que se aplicaron en la última búsqueda
        const response = await BackofficeApi.post(path, this.currentFilters, {
          responseType: "blob"
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", this.excelName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (e) {
        console.error("Error al descargar el Excel:", e);
        alert("Error al descargar el Excel. Por favor, intente nuevamente.");
      } finally {
        this.isExporting = false;
      }
    }
  },
  watch: {
    darkKitchenId(val) {
      if (!val) return;
      if (!this.loaded && !this.isLoading) {
        this.fetchFeedbacks();
      }
    },
    // Eliminamos el watch de dateRange para que no se apliquen los filtros automáticamente
    searchQuery(value) {
      // Solo actualiza la búsqueda local, no hace peticiones al servidor
      this.fuseSearch = new Fuse(this.feedbacks, {
        keys: ["customer", "branch_office", "platos"],
        threshold: 0.3
      });
      let result = this.feedbacks;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-table .cell {
  word-break: break-word !important;
}
</style>
